<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-card class="mt-2 mx-0 border-none p-0">
      <b-card-header id="sabrepnr-card-header" class="pl-2 pr-3 small">
        <!-- {{ $moment().diff($moment(sabrepnr.timestamp,'DD/MM/YYYY HH:mm:SS'), 'minutes') }} -->
        Sabre PNR ( Navitas )
        <div class="card-header-actions">
          {{ sabrepnr.timestamp }}
          <span
            id="sabrepnr_ago"
            :class="'ml-2 status-dot ' + lastrunstatus"
            pulse="true"
          ></span>
        </div>
      </b-card-header>
      <b-tooltip target="sabrepnr-card-header" triggers="hover"
        >Navitas Robotic checking the Sabre 499 queue</b-tooltip
      >
      <b-tooltip target="sabrepnr_ago" triggers="hover">{{
        $moment(sabrepnr.timestamp, "DD/MM/YYYY HH:mm:SS") | formatTimeago
      }}</b-tooltip>
      <b-card-body class="px-0 pt-0" >
        <b-table
          v-if="sabrepnr.showtable"
          ref="logtable"
          id="logtable"
          striped
          sticky-header="500px"
          fixed
          small
          bordered
          :items="items"
          :fields="sabrepnr.fields"
          class="gridtable my-0"
        ></b-table>
        <b-row class="excelsheetbuttons">
          <b-col>
            <b-button-group>
              <b-button
                :pressed="true"
                squared
                size="sm"
                variant="outline-secondary"
                id="sabrepnr_log"
              >
                <i class="fa fa-list-ol"></i>
              </b-button>
              <b-tooltip target="sabrepnr_log" triggers="hover"
                >Show log</b-tooltip
              >
            </b-button-group>
          </b-col>
          <b-col class="text-right">
            <!-- <b-button-group>
              <b-button size="sm" squared :pressed="true" variant="outline-secondary" class="mr-1">
                <i class="fa fa-list-ul"></i>
                 <span class="pl-1">
                  <nobr />
                  {{sabrepnr.items.length}}
                  <nobr />
                </span>
              </b-button>
            </b-button-group>-->

            <!--    <b-button
                variant="outline-primary"
                :pressed="sabrepnr.format=='grid'"
                @click="outputSwitch()"
                title="Send to screen"
              >
                <i class="fa fa-desktop" aria-hidden="true"></i>
            </b-button>-->

            <b-link
              id="sabrepnr-start"
              disabled
              @click="action('start')"
              size="sm"
              class="mt-1 mr-2 text-primary"
            >
              <i class="fa fa-play"></i>
            </b-link>
            <b-tooltip target="sabrepnr-start" triggers="hover"
              >Start service</b-tooltip
            >

            <b-link
              id="sabrepnr-end"
              disabled
              @click="action('stop')"
              size="sm"
              class="mt-1 mr-2 text-danger"
            >
              <i class="fa fa-stop"></i>
            </b-link>
            <b-tooltip target="sabrepnr-end" triggers="hover"
              >Stop service</b-tooltip
            >
            <b-link
              id="sabrepnr-excel"
              class="mt-1 excel"
              @click="$helpers.outputExcel({ items, fields: options.fields })"
              title="Send to excel"
            >
              <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            </b-link>
            <b-tooltip target="sabrepnr-excel" triggers="hover"
              >Grid to excel</b-tooltip
            >
            <!--      <b-link
                class="mt-1"
                squared
                size="sm"
                variant="outline-primary"
                title="Expand/collapse"
                @click="sabrepnr.showtable=!sabrepnr.showtable"
              >
                <i v-if="sabrepnr.showtable" class="fa fa-arrow-up"></i>
                <i v-if="!sabrepnr.showtable" class="fa fa-arrow-down"></i>
            </b-link>-->
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-2">
          <b-col>
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
              <span class="small text-primary ml-2">Updating ...</span>
            </div>
            <span v-if="!busy" class="small text-primary"
              >Showing last {{ sabrepnr.items.length }} message(s)</span
            >
            <br />
            <span v-if="!busy" class="small text-primary">{{
              sabrepnr.actionmessage
            }}</span>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import moment from "moment";

export default {
  name: "SabrePNRStatus",
  props: ["tile", "refresh"],
  data() {
    return {
      busy: false,
      timeout: false,
      name: "SabrePNRStatus",
      sabrepnr: {
        // lastrunstatus: "success",
        timestamp: "Unknown",
        running: true,
        actionmessage: "",
        status: "negative",
        showtable: true,
        format: "grid",
        fields: [
          {
            key: "date",
            label: "Date and Time",
            sortable: true,
            sortDirection: "desc",
            class: "w-30pct",
          },
          {
            key: "message",
            label: "Message",
            sortable: true,
            sortDirection: "desc",
            class: "w-75pct",
          },
        ],
        items: [
          {
            updated_at: this.$moment().format("x") / 1000,
            name: "Log4Net test message",
          },
        ],
      },
    };
  },
  async mounted() {
    this.$helpers.resizableColumns();
    await this.loadChart();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
  },
  computed: {
    items() {
      return this.sabrepnr.items;
    },
    chartType() {
      if (this.tile.settings) {
        let setting = this.tile.settings.find((o) => o.key == "type");
        return setting.value;
      } else {
        return "Table";
      }
    },
    lastrunstatus() {
      let result = "danger";
      if (this.sabrepnr.timestamp != "Unknown") {
        let minutes = this.$moment().diff(
          this.$moment(this.sabrepnr.timestamp, "DD/MM/YYYY HH:mm:SS"),
          "minutes"
        );
        if (minutes <= 5) {
          result = "success";
        } else if (minutes > 5 && minutes < 60) {
          result = "warning";
        } else {
          result = "danger";
        }
      }
      return result;
    },
  },
  methods: {
    async loadChart() {
      console.log("loadChart: SabrePNRStatus");

      this.busy = true;
      let variables = {};
      variables.id = "navitas_log";
      try {
        const response = await this.$apollo.query({
          query: gql`
            query file_date($id: String) {
              file_date(id: $id)
            }
          `,
          variables,
        });
        if (response.data.file_date) {
          this.sabrepnr.timestamp = this.$moment
            .unix(response.data.file_date / 1000)
            .format("DD/MM/YYYY HH:mm:SS");
        }
        try {
          const response = await this.$apollo.query({
            query: gql`
              query file_read($id: String) {
                file_read(id: $id)
              }
            `,
            variables,
          });
          this.sabrepnr.items = [];
          let contents = JSON.parse(response.data.file_read);
          if (contents) {
            contents = contents.split("}");
            for (var j = contents.length - 1; j >= 0; j--) {
              try {
                let obj = JSON.parse(contents[j] + "}");
                obj.date = this.$moment(obj.date).format("DD/MM/YYYY HH:mm:SS");
                this.sabrepnr.items.push(obj);
                if (this.sabrepnr.items.length > 199) {
                  break;
                }
              } catch (error) {
                console.log(j, error);
              }
            }
          }
        } catch (error) {
          console.log(error);
        }
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
      await this.$emit("refreshed");
    },

    async action(e) {
      console.log("action", e);
      let cmd = e;
      if (e.key) {
        cmd = e.key;
      }

      switch (cmd) {
        case "start":
          this.sabrepnr.running = true;
          // await this.exec("net start TravelPlacesProcessor");
          await this.exec("net start W3SVC");
          break;

        case "stop":
          this.sabrepnr.running = false;
          // await this.exec("net stop TravelPlacesProcessor");
          await this.exec("net stop W3SVC");
          break;

        case "refresh":
          await this.loadChart();
          break;
      }
    },
    async exec(e) {
      this.busy = true;
      let variables = {};
      variables.cmd = e;
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation($cmd: String!) {
              exec(cmd: $cmd)
            }
          `,
          variables,
        });
        this.sabrepnr.actionmessage = response.data.exec;
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
  },
};
</script>


<style>
</style>